<template>
  <div class="crowdDetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <swiper :options="swiperOption">
      <swiper-slide class="swiper-slide games">
        <a href=""><img :src="baseUrl+setDetail.images"></a>
      </swiper-slide>
    </swiper>
    <div class="cont">
      <div class="info">
        <h2 class="title"><div>{{setDetail.title}}</div>
          <span>￥{{setDetail.rate/setDetail.group_num}}元一股</span>
          <span class="curt">共{{setDetail.group_num}}股</span>
        </h2>
        <h2 style="padding-bottom:10px">
          <p>周一至周日</p>
          <p>有效期：{{setDetail.expired}}年</p>
          <p>投放地址：{{setDetail.address}}</p>
          <p>收益公式：((咖啡订单的金额×{{setDetail.cash}}%)÷{{setDetail.group_num}}股)×您所购买的股数 = 您的收益</p>
        </h2>
        <h2 class="box" @click="toPush(setDetail.deviceUuid,'turnover')">咖啡机订单流水：<a>{{setDetail.device}}单<i class="el-icon-arrow-right"></i></a></h2>
        <!--<h2 class="box" @click="toPush(setDetail.id,'crowd-share')">入股用户：<a>{{setDetail.total}}人<i class="el-icon-arrow-right"></i></a></h2>-->
        <h2 class="box">咨询电话：<a href="tel:18587718850">tel:18587718850<i class="el-icon-arrow-right"></i></a></h2>
        <h2 class="box" @click="toPush(setDetail.deviceUuid,'ctotal')">咖啡数据统计：<a>查看<i class="el-icon-arrow-right"></i></a></h2>
        <div class="goDetail" @click="toPush(setDetail.id,'crowdinfo')">详情<i class="el-icon-arrow-right"></i></div>
      </div>
      
    </div>
    <div style="height:55px"></div>
    <div class="footer1">
      <div class="foot-title">
        <span>合计：<i>￥</i><b>{{setDetail.rate/setDetail.group_num}}</b>
        </span>
        <span>一股起购</span>
      </div>
      <div v-if="setDetail.group_num >= setDetail.total" class="pay" @click="toPush(setDetail.id,'crowd-payment')">
        <span>立即入股</span>        
      </div>
      <div v-else class="pay">
        <span style="background:#bbb">售罄</span>        
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default {
    data() {
      return {
        swiperOption: {
          autoplay : {
            disableOnInteraction: false, //用户操作后是否禁止自动循环
            delay: 1000 //自自动循环时间
          }, //可选选项，自动滑动
          initialSlide: 0,
          speed: 1000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
          loop:false, //循环切换
          grabCursor: true, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
          autoHeight: true,   //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true, //设置为true时，能使用鼠标滚轮控制slide滑动
          observeParents: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
       
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },
        userData:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        setDetail:[],
        positionFlag:false,
        code:'',
      };
    },
    created(){
    },
    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var url = encodeURIComponent('http://user.4008005216.com/main/crowd-detail?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      this.getDetail()
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/crowdDetail',
          params:{
            id:id,
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data;
          that.setDetail = res.data;
          that.getQquey();
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },


      getQquey:function(){
        var that = this;
        var id = that.$route.query.id;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'onMenuShareAppMessage',
              'onMenuShareTimeline'
            ]
          });
          wx.ready(function() {
            //分享到朋友圈
            wx.onMenuShareTimeline({
                title:that.setDetail.title, // 分享标题
                link:'http://user.4008005216.com/main/crowd-detail?id='+id, 
                imgUrl:that.baseUrl+that.setDetail.images, // 分享图标
                success: function () {
                },
            });
            //分享给朋友
            wx.onMenuShareAppMessage({
                title:that.setDetail.title,
                desc:'收益公式：((咖啡订单的金额×'+that.setDetail.cash+'%)÷'+that.setDetail.group_num+'股)×您所购买的股数 = 您的收益',
                link:'http://user.4008005216.com/main/crowd-detail?id='+id,
                imgUrl: that.baseUrl+that.setDetail.images, 
                type: '',
                dataUrl: '', 
                success: function () {
                }
            });
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          that.getDetail();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .crowdDetailApp{
    background:#ececec;
    width:100%
  }
  .crowdDetailApp .swiper-slide{
    width:100%
  }
  .crowdDetailApp .swiper-slide img{
    display:block;
    width:100%;

  }
  .crowdDetailApp .cont{
    width:94%;
    display:block;
    margin:0 auto;
    z-index:99;
    position:relative;
    top:-60px;
  }
  .crowdDetailApp .info{
    width:100%;
    display:block;
    position:relative;
    background:#fff;
    border-radius:6px;
  }
  .crowdDetailApp .info .goDetail{
    position:absolute;
    right:3%;
    transform: translateY(-50%);
    top:20%;
    font-size:14px;
    color:#666
  }
  .crowdDetailApp .info h2{
    font-size:15px;
    padding-top:10px;
    width:92%;
    display:block;
    margin:0 auto;
    font-weight:normal;
    color:#333;
  }
  .crowdDetailApp .info h2.box{
    border-top:solid 1px #f5f5f5;
    padding:15px 0
  }
  .crowdDetailApp .info h2 p{
    padding-bottom:5px;
    line-height:22px
  }
  .crowdDetailApp .info h2.title{
    color:#000;
    font-weight:bold;
    font-size:16px;
    padding:15px 0 12px 0
  }
  .crowdDetailApp .info h2.title div{
    margin-bottom:8px
  }
  .crowdDetailApp .info h2.title span{
    font-weight:normal;
    display:inlie-block;
    border:solid 1px #F56C6C;
    font-size:12px;
    padding:3px 5px;
    border-radius: 4px;
    color:#F56C6C;
    margin-right:8px;
  }
  .crowdDetailApp .info h2.title span.curt{
    color:#67C23A;
    border-color:#67C23A
  }
  .crowdDetailApp .info h2 a{
    color:#999;
    text-decoration: none;
    float:right
  }

  .crowdDetailApp .footer1{
    height: 50px;
    background: #fff;
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0;
    z-index: 999
  }
  .crowdDetailApp .footer1 .foot-title{
    float: left;
    margin-left: 4%;
    height:50px;
    line-height:50px;
  }
  .crowdDetailApp .footer1 .foot-title span{
    font-size: 14px;
    color: #727272;
  }
  .crowdDetailApp .footer1 .foot-title span:first-child{
    margin-right:8px
  }
  .crowdDetailApp .footer1 .foot-title span b{
    color: #f00;
    font-size:17px;
    font-weight:500;
  }

  .crowdDetailApp .footer1 .foot-title span i{
    color: #f00;
    font-size:12px;
    font-style:normal
  }

  .crowdDetailApp .footer1 .pay{
    float: right;
    color: #fff;
    margin-right: 4%;
    margin-top:5px;
    width:40%
  }
  .crowdDetailApp .footer1 .pay span{
    float:left;
    height:40px;
    line-height:40px;
    font-size: 14px;
    width:100%;
    text-align:center;
    font-weight:bold;
    background: #f00;
    border-radius:40px;
  }

</style>